import { UpdateFinanceTradesAdditionsApi } from "@/features/accounts/finance/services/update-trades-additions-api";
import { UpdateFinanceTradesAdditionsRequestModel } from "@/features/accounts/finance/services/update-trades-additions-model";

/// 銀行明細メモ・無効明細更新処理
export class UpdateFinanceTradesAdditionsService {
  private updateFinanceTradesAdditionsApi = new UpdateFinanceTradesAdditionsApi();

  /**
   * 銀行明細メモ・無効明細更新API実行
   */
  public async updateFinanceTradesAdditions(param: UpdateFinanceTradesAdditionsRequestModel) {
    return await this.updateFinanceTradesAdditionsApi.updateFinanceTradesAdditions(param);
  }
}
